<template>
  <div>
    <h3>General description</h3>

    The maneuver analysis mission has been designed to help the user understand
    the space environment and to assess the mobility capabilities of different
    space objects. This mission is going to use available measures imported by
    the user for different space objects (one space object per mission) and
    analyze them.
    <p>
      The measurements used for the mission are the SP_Ephemerides from the SSA
      organization SpaceTrack.
    </p>

    During the analysis, the software is going to detect the different orbital
    changes and fit a potential maneuver resulting in the mobility capabilities
    of such orbital change. Different metrics of the found mobility capabilities
    and maneuver are displayed, and will be used in the future as inputs to new
    missions.
    <p>
      In addition, during the analysis of the measurements, the ballistic
      coefficient for when no orbital changes were detected is also computed.
    </p>

    <h3>Hypotheses</h3>
    <p>The underlying assumptions for this module are the following:</p>
    <ul>
      <li>The spacecraft in the space object has a spherical geometry.</li>
      <li>
        The selected SP measurements to analyse should be overlapping. The
        propagated measures in a SP file should run at least to the date of the
        next SP measurements file.
      </li>
      <li>
        Maneuver detection will only occur if the orbital change is higher than
        a threshold (<katex-element expression="thr_{sma} = 100 m" /> and
        <katex-element expression="thr_{inc} = 0.01 \degree" />).
      </li>
      <li>
        Maneuver analysis will converge on semi major axis and inclination
        orbital transfers and on orbit phasing maneuvers.
      </li>
      <li>
        The resulting mobility capability assumes the spacecraft was firing its
        thruster at every orbit to reach its final orbit.
      </li>
      <li>
        The resulting mobility capability assumes the spacecraft was firing its
        thruster at every orbit to reach its final orbit.
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'tooltipManeuverAnalysisMission'
}
</script>
